import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider, applyTheme, getInitialTheme } from './contexts/ThemeContext';
import { ConfirmProvider, AlertProvider } from './shared/hooks';
import App from './App';
import { installChunkErrorListeners } from './shared/utils/chunkErrorListeners';
import './styles.css';

// 初始化 i18n
import './i18n';

installChunkErrorListeners();

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000, // 5 minutes
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});

applyTheme(getInitialTheme());

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ThemeProvider>
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <AuthProvider>
                        <AlertProvider>
                            <ConfirmProvider>
                                <App />
                            </ConfirmProvider>
                        </AlertProvider>
                    </AuthProvider>
                </BrowserRouter>
                <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
        </ThemeProvider>
    </React.StrictMode>
);
